import { render, staticRenderFns } from "./receivingAccount.vue?vue&type=template&id=fb584cce&scoped=true&"
import script from "./receivingAccount.vue?vue&type=script&lang=js&"
export * from "./receivingAccount.vue?vue&type=script&lang=js&"
import style0 from "./receivingAccount.vue?vue&type=style&index=0&id=fb584cce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb584cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fb584cce', component.options)
    } else {
      api.reload('fb584cce', component.options)
    }
    module.hot.accept("./receivingAccount.vue?vue&type=template&id=fb584cce&scoped=true&", function () {
      api.rerender('fb584cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/receivingAccount.vue"
export default component.exports